// Test if `text` has a match in the `regexList`.
function testSome(regexList: Array<RegExp>, text: string) {
    return regexList.some((rx) => rx.test(text));
}

export default testSome;
